<form [formGroup]="formGroup">
    <div class="alert is-shadowless is-radiusless">
        <div class="body">
            <div class="is-multiline is-flex is-justified-center">
                <div class="popover is-popover-right">
                    <a title="Client PRO" class="icon is-large is-pulled-right">
                        <i (click)="setIsPro()" class="tri-user-tie"></i>
                    </a>
                    <div class="popover-content">
                        <p>Passer en PRO</p>
                    </div>
                </div>
                <div class="popover is-popover-right">
                    <a title="Reprise mobile" class="icon is-large is-pulled-right">
                        <i (click)="addRecovery()" class="tri-mobile-recovery"></i>
                    </a>
                    <div class="popover-content">
                        <p>Ajouter une reprise mobile</p>
                    </div>
                </div>
                <div class="popover is-popover-right">
                    <a title="convergence" class="icon is-large is-pulled-right">
                        <i (click)="addConvergence()" class="tri-box-mobile"></i>
                    </a>
                    <div class="popover-content">
                        <p>Ajout convergence</p>
                    </div>
                </div>
                <div class="popover is-popover-right">
                    <a title="Renouvellement" class="icon is-large is-pulled-right">
                        <i
                            (click)="toggleRenew()"
                            [ngClass]="{ 'is-success': isRenewal }"
                            class="tri-mobile-up-down"
                        ></i>
                    </a>
                    <div class="popover-content">
                        <p>Passer en renouvellement</p>
                    </div>
                </div>
                <div class="popover is-popover-right">
                    <a title="EDP" class="icon is-large is-pulled-right">
                        <i
                            [checkoutCy]="'mock-product-edp'"
                            (click)="setFundingEdp()"
                            [ngClass]="{ 'is-success': hasEdp }"
                            class="tri-file-euro"
                        ></i>
                    </a>
                    <div class="popover-content">
                        <p>Ajouter l'EDP</p>
                    </div>
                </div>
                <div class="popover is-popover-right">
                    <a title="Default Payment" class="icon is-large is-pulled-right">
                        <i (click)="setFundingYounited()" class="tri-credit-cards-12"></i>
                    </a>
                    <div class="popover-content">
                        <p>Paiement avec Younited</p>
                    </div>
                </div>
                <div class="popover is-popover-right">
                    <a title="Default Payment" class="icon is-large is-pulled-right">
                        <i (click)="setFundingCash()" class="tri-euros"></i>
                    </a>
                    <div class="popover-content">
                        <p>Paiement CASH</p>
                    </div>
                </div>
                <div class="popover is-popover-right">
                    <a title="Default Payment" class="icon is-large is-pulled-right">
                        <i (click)="getScoring()" class="tri-applicationrdr"></i>
                    </a>
                    <div class="popover-content">
                        <p>Scoring</p>
                    </div>
                </div>
                <div class="popover is-popover-right">
                    <a title="Default Payment" class="icon is-large is-pulled-right">
                        <i (click)="setPromoBanner()" class="tri-bell-ringing"></i>
                    </a>
                    <div class="popover-content">
                        <p>Bannière promo</p>
                    </div>
                </div>
            </div>
            <div class="container">
                <div class="divider"></div>
                <div>
                    <div class="is-multiline buttons">
                        @for (product of plans; track product) {
                            <a
                                (click)="addProduct(product)"
                                [checkoutCy]="'mock-product-' + product.gencode"
                                class="button is-primary is-small mt-1"
                            >
                                {{ product.label }}
                            </a>
                        }
                    </div>
                </div>
                <div class="divider"></div>
                <div>
                    <div class="is-multiline buttons">
                        @for (product of phones; track product) {
                            <a
                                (click)="addProduct(product)"
                                [checkoutCy]="'mock-product-' + product.gencode"
                                class="button is-primary is-small mt-1"
                            >
                                {{ product.label }}
                            </a>
                        }
                    </div>
                </div>
                <div class="divider"></div>
                <div>
                    <div class="is-multiline buttons">
                        @for (product of fai; track product) {
                            <a
                                (click)="addProduct(product, true)"
                                [checkoutCy]="'mock-product-' + product.gencode"
                                class="button is-primary is-small mt-1"
                            >
                                {{ product.label }}
                            </a>
                        }
                    </div>
                </div>
                <div class="divider"></div>
                <div>
                    <div class="is-multiline buttons">
                        @for (product of accessories; track product) {
                            <a
                                (click)="addProduct(product)"
                                [checkoutCy]="'mock-product-' + product.gencode"
                                class="button is-primary is-small mt-1"
                            >
                                {{ product.label }}
                            </a>
                        }
                    </div>
                </div>
                <div class="divider"></div>
                <div>
                    <div class="is-multiline buttons">
                        @for (product of options; track product) {
                            <a
                                (click)="addProduct(product)"
                                [checkoutCy]="'mock-product-' + product.gencode"
                                class="button is-primary is-small mt-1"
                            >
                                {{ product.label }}
                            </a>
                        }
                    </div>
                </div>
                <div class="divider"></div>
                <div>
                    <div class="is-multiline buttons">
                        <a
                            (click)="
                                addPack(
                                    'pack-apple-iphone-15-pro-max-titane-bleu-256-go_sensation-pro-smartphone-300go-6763'
                                )
                            "
                            class="button is-primary is-small mt-1"
                        >
                            Pack FAM (300go + iPhone 15 pro max)
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
